import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { Badge } from "@/components/ui";
import AIBadge from "@/components/ui/ai-badge";
import { useCommunication } from "@/contexts/chat-provider";
import { formatDateTime, formatStaffName, formatToHumanReadable } from "@/lib/format-data";
import { getMessageBadgeVariant } from "@/lib/message-type-styles";
import { UserType } from "@/types/enums";
import { MessageSummary } from "@/types/message";
import { UserTiny } from "@/types/user";
import { eventQueryOptions } from "@/query/check-in/calendar/event-query";
export const EventMessageList = t0 => {
  const $ = _c(9);
  const {
    eventId,
    patient
  } = t0;
  let t1;
  if ($[0] !== eventId) {
    t1 = eventQueryOptions.eventMessages(eventId);
    $[0] = eventId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: messages,
    isPending
  } = useQuery(t1);
  const {
    openChat
  } = useCommunication();
  let t2;
  if ($[2] !== isPending || $[3] !== messages || $[4] !== openChat || $[5] !== patient) {
    t2 = isPending || !messages ? <div className="space-y-4">{[1, 2, 3].map(_temp)}</div> : messages.map(message => <div key={message.id} className="rounded-md border bg-background/60 p-3" onClick={() => {
      if (patient) {
        openChat(patient.id);
      }
    }}><div className="flex"><p className="text-caption text-primary"><span className="flex items-center gap-1 font-bold">{message.sender.type === UserType.ASSISTANT && <AIBadge />}<span>{formatStaffName(message.sender)}</span></span><span className="text-tiny text-muted-foreground">{formatDateTime(message.createdDate)}</span></p>{message.type && <Badge className="ml-2 inline-flex h-fit p-1 text-tiny leading-none" variant={getMessageBadgeVariant(message.type)}>{formatToHumanReadable(message.type)}</Badge>}</div><p className="text-caption text-foreground-secondary">{message.content}</p></div>);
    $[2] = isPending;
    $[3] = messages;
    $[4] = openChat;
    $[5] = patient;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="mt-2 flex flex-col gap-1 rounded-md bg-muted p-1.5">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
function _temp(item) {
  return <div key={item} className="space-y-2"><div className="h-12 w-full animate-pulse rounded-md border  p-3" /></div>;
}